export const studentReducer = (state = { loading: false, students: [], currentStudent: null, studentError: null }, action) => {
    switch (action.type) {
        case 'STUDENTS_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'STUDENTS_SUCCESS':
            return {
                ...state,
                loading: false,
                students: action.payload,
                studentError: null
            }
        case 'STUDENT_SUCCESS':
            return {
                ...state,
                loading: false,
                currentStudent: action.payload,
                studentError: null
            }
        case 'STUDENT_ERROR':
            return {
                ...state,
                loading: false,
                currentStudent: null,
                studentError: action.payload
            }
        default:
            return state
    }
}
